import React, { createContext, useContext, useState, useCallback } from 'react';
import { Joyride, STATUS, ACTIONS } from 'react-joyride';
import { useTranslation } from 'react-i18next';

const TourContext = createContext(null);

export const TourProvider = ({ children }) => {
    const { t } = useTranslation();
    const [steps, setSteps] = useState([]);
    const [isRunning, setIsRunning] = useState(false);
    const [tourKey, setTourKey] = useState(0);

    const startTour = useCallback((tourSteps) => {
        setSteps(tourSteps);
        setTourKey(k => k + 1);
        setIsRunning(true);
    }, []);

    const stopTour = useCallback(() => {
        setIsRunning(false);
    }, []);

    const handleJoyrideCallback = (data) => {
        const { action, status } = data;

        if (
            action === ACTIONS.CLOSE ||
            status === STATUS.FINISHED ||
            status === STATUS.SKIPPED
        ) {
            stopTour();
        }
    };

    return (
        <TourContext.Provider value={{ startTour, stopTour, isRunning }}>
            <Joyride
                key={tourKey}
                steps={steps}
                run={isRunning}
                continuous
                showProgress
                showSkipButton
                scrollToFirstStep
                disableOverlayClose
                callback={handleJoyrideCallback}
                options={{
                    primaryColor: '#fd4701',
                    zIndex: 9999,
                }}
                styles={{
                    tooltipContainer: {
                        textAlign: 'left',
                    },
                    buttonPrimary: {
                        backgroundColor: '#fd4701',
                    },
                    buttonBack: {
                        color: '#fd4701',
                    },
                }}
                locale={{
                    back: t('tour.locale.back'),
                    close: t('tour.locale.close'),
                    last: t('tour.locale.last'),
                    next: t('tour.locale.next'),
                    skip: t('tour.locale.skip'),
                }}
            />
            {children}
        </TourContext.Provider>
    );
};

export const useTour = () => {
    const context = useContext(TourContext);
    if (!context) {
        throw new Error('useTour must be used inside TourProvider');
    }
    return context;
};
